/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      function filterEvents( page ) {
        const types = [];
        $( '.event-filters input[name="lc_event_type"]:checked' ).each( function() {
          types.push( $( this ).val() );
        } );

        const audiences = [];
        $( '.event-filters input[name="lc_event_audience"]:checked' ).each( function() {
          audiences.push( $( this ).val() );
        } );

        let cost = 'either';
        const costs = [];
        $( '.event-filters input[name="event_tickets_with_admission"]:checked' ).each( function() {
          costs.push( $( this ).val() );
        } );

        if ( costs.includes( 'free' ) && !costs.includes( 'paid' ) ) {
          cost = 'free';
        } else if ( !costs.includes( 'free' ) && costs.includes( 'paid' ) ) {
          cost = 'paid';
        }

        const data = {
          'types': types,
          'audiences': audiences,
          'cost': cost,
          'page': page ? page : 1,
        };

        $.ajax( {
          type: 'GET',
          url: siteInfo.wpApiSettings.ll + 'cpt/filterEvents', // note that cpt/filter is the path set in our new route in routes.php
          data: data,
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            console.log( data );
            $( '.events-area' ).html( data.events );
          },
          complete: function( jqXHR, status ) {
            doingAjax = false;
          },
        } );
      }

      $( document ).on( 'change', '.event-filters input', function() {
        let currentPage = 1;

        // Update the aria-checked attribute based on the checkbox state
        $( this ).attr( 'aria-checked', $( this ).is( ':checked' ) ? 'true' : 'false' );

        if ( $( '.events-area .pagination .current' ).length ) {
          currentPage = $( '.events-area .pagination .current' ).text();
        }

        filterEvents( currentPage );
      } );

      $( document ).on( 'click', '.pagination button', function() {
        filterEvents( $( this ).attr( 'data-value' ) );
      } );

      $( document ).on( 'click', '.clear-filters', function() {
        $( '.event-filters input' ).prop( 'checked', false );
        filterEvents( 1 );
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'calendar', COMPONENT );
} )( app );
